module.exports = __webpack_public_path__ + "img/thumbnail_Moose_j_normal.d4626adb.png";